import { InputGroupField } from 'cwp-components/forms'
import React, { useEffect, useState } from 'react'
import { BsSearch } from 'react-icons/bs'
import { Tag } from '../extra/Tag'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

export const SearchByLawSection = () => {
  const { tags, loadTags } = useArticleTemplate({ pageSize: 1 })

  useEffect(loadTags, [loadTags])

  const [filteredTags, setFilteredTags] = useState<any>(tags)
  const [tagValue, setTagValue] = useState('')

  const handleTagSearchInputChange = (e: any) => {
    setTagValue(e.target.value)
  }

  useEffect(() => {
    setFilteredTags(tags.filter((tag) => tag.name.includes(tagValue)))
  }, [tags, tagValue])

  return (
    <div className='flex flex-col gap-6'>
      <h3 className='font-bold text-lg md:text-2xl lg:text-[32px] text-[#001A3D]'>
        Search by law
      </h3>

      <InputGroupField
        placeholder='Search for a tag'
        Icon={BsSearch}
        reverse
        name='tag'
        onChange={handleTagSearchInputChange}
        value={tagValue}
        className=''
      />

      <div className='flex flex-wrap gap-4'>
        {filteredTags.slice(0, 10).map((tag, idx) => (
          <button
          // onClick={}
          >
            <Tag
              key={tag.name + idx}
              text={tag.name}
              className='text-xs lg:text-base px-[8px] py-[4px] font-medium'
            />
          </button>
        ))}
      </div>
    </div>
  )
}
